import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { toast } from '@/lib/toast'

export function useEducation() {
  return useQuery({
    queryKey: ['my-education'],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) return []
      const { data, error } = await supabase.from('resident_education')
        .select('*').eq('resident_id', session.user.id).order('year_started', { ascending: false })
      if (error) throw error
      return data ?? []
    },
  })
}

export function useCreateEducation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (input: Record<string, unknown>) => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) throw new Error('Not authenticated')
      const { error } = await supabase.from('resident_education').insert({ ...input, resident_id: session.user.id })
      if (error) throw error
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['my-education'] }); toast.success('Saved') },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useUpdateEducation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, ...fields }: Record<string, unknown> & { id: string }) => {
      const { error } = await supabase.from('resident_education').update(fields).eq('id', id)
      if (error) throw error
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['my-education'] }); toast.success('Saved') },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useDeleteEducation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from('resident_education').delete().eq('id', id)
      if (error) throw error
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['my-education'] }); toast.success('Removed') },
    onError: (err: Error) => toast.error(err.message),
  })
}
